module.exports = __webpack_public_path__ + "img/r_hone_icon_04.413c5033.png";